
import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { AppAuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class DirectoryAccessService {
  private auth = inject(AppAuthService);

  globalUnlocked = signal(false);
  allowedOffices = signal<number[]>([]);

  constructor() {
effect(() => {
    const perms = this.auth.userPerms();
    if (perms) {
      if(perms.some((perm) => perm.dataTable === 'Users' && perm.permType === 'edit' && perm.FID === null)) {
        this.globalUnlocked.set(true);
        console.log('global unlocked');
      } else {
        this.globalUnlocked.set(false);
        this.allowedOffices.set(perms.filter((perm) => perm.dataTable === 'Users' && perm.permType === 'edit' && perm.FID !== null).map((perm) => perm.FID));
        console.log('allowed offices', this.allowedOffices());
      }
    }
  });
  }

}

